let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bnXfh")).then(() => parcelRequire('d6lfc'));